import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService, LocaleDataService } from "@atenea-cms";
import { DownloadType } from "../../download-types/shared";

@Component({
  selector: "product-download-form",
  templateUrl: "./product-download-form.component.html",
  styleUrls: ["./product-download-form.component.scss"],
})
export class ProductDownloadFormComponent {
  @Input() form: FormGroup;
  @Input() downloadTypes: Array<DownloadType> = [];

  constructor(
    public ft: FormToolsService,
    private localeService: LocaleDataService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-download-form/product-download-form.component.ts